import React, { useState, useEffect } from 'react';
import { submitContactMessage, getCompanyInfo } from '../api/api';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const [companyInfo, setCompanyInfo] = useState(null);

  useEffect(() => {
    getCompanyInfo()
      .then(response => setCompanyInfo(response.data))
      .catch(error => console.error('Eroare la încărcarea informațiilor:', error));
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess(false);

    try {
      const response = await submitContactMessage(formData);
      setSuccess(true);
      setFormData({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: '',
      });
      alert(response.data.message || 'Mesajul a fost trimis cu succes!');
    } catch (err) {
      setError('A apărut o eroare. Te rugăm să încerci din nou.');
      console.error('Eroare la trimiterea mesajului:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-page">
      <section className="page-header">
        <div className="container">
          <h1>Contactează-ne</h1>
          <p>Suntem aici pentru TINE! Hai să creăm împreună proiectul tău de vis.</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="contact-content">
            {/* Contact Info */}
            <div className="contact-info">
              <h2>Informații Contact</h2>
              
              {companyInfo && (
                <>
                  <div className="info-item">
                    <div className="icon">📧</div>
                    <div>
                      <h3>Email</h3>
                      <p><a href={`mailto:${companyInfo.email}`}>{companyInfo.email}</a></p>
                    </div>
                  </div>

                  <div className="info-item">
                    <div className="icon">📞</div>
                    <div>
                      <h3>Telefon</h3>
                      <p><a href={`tel:${companyInfo.phone}`}>{companyInfo.phone}</a></p>
                    </div>
                  </div>

                  <div className="info-item">
                    <div className="icon">📍</div>
                    <div>
                      <h3>Adresă</h3>
                      <p>{companyInfo.address}</p>
                    </div>
                  </div>

                  <div className="social-links">
                    <h3>Urmărește-ne</h3>
                    <div className="social-icons">
                      {companyInfo.facebook && (
                        <a href={companyInfo.facebook} target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Facebook">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                          </svg>
                        </a>
                      )}
                      {companyInfo.twitter && (
                        <a href={companyInfo.twitter} target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="X">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                            <path fill="currentColor" d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584l-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z"/>
                          </svg>
                        </a>
                      )}
                      {companyInfo.instagram && (
                        <a href={companyInfo.instagram} target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Instagram">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                            <g fill="none" fillRule="evenodd">
                              <path d="M24 0v24H0V0h24ZM12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035c-.01-.004-.019-.001-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.017-.018Zm.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022Zm-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01l-.184-.092Z"/>
                              <path fill="currentColor" d="M16 3a5 5 0 0 1 5 5v8a5 5 0 0 1-5 5H8a5 5 0 0 1-5-5V8a5 5 0 0 1 5-5h8Zm0 2H8a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h8a3 3 0 0 0 3-3V8a3 3 0 0 0-3-3Zm-4 3a4 4 0 1 1 0 8a4 4 0 0 1 0-8Zm0 2a2 2 0 1 0 0 4a2 2 0 0 0 0-4Zm4.5-3.5a1 1 0 1 1 0 2a1 1 0 0 1 0-2Z"/>
                            </g>
                          </svg>
                        </a>
                      )}
                      {companyInfo.linkedin && (
                        <a href={companyInfo.linkedin} target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="LinkedIn">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"/>
                            <circle cx="4" cy="4" r="2"/>
                          </svg>
                        </a>
                      )}
                      {companyInfo.tiktok && (
                        <a href={companyInfo.tiktok} target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="TikTok">
                          <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
                            <path fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M17.045 20.667C10.564 21.117 5 25.736 5 32.815C5 39.545 10.393 45 17.045 45s12.046-5.455 12.046-12.185l-.348-15.19c3.027 2.336 7.862 3.748 12.336 3.974c.8.04 1.568-.323 1.755-1.103c.095-.397.166-.914.166-1.573s-.07-1.176-.166-1.573c-.187-.78-.956-1.118-1.754-1.198c-6.05-.605-11.747-5.5-12.561-11.28c-.104-.73-.513-1.405-1.228-1.591A8.8 8.8 0 0 0 25.076 3a8.8 8.8 0 0 0-2.218.281c-.713.186-1.139.856-1.156 1.594l-.642 27.94c0 2.243-1.797 4.062-4.015 4.062s-4.015-1.819-4.015-4.062c0-2.332 1.95-3.833 4.015-4.217"/>
                          </svg>
                        </a>
                      )}
                    </div>
                  </div>
                </>
              )}

              <div className="working-hours">
                <h3>Program</h3>
                <p>Luni - Vineri: 09:00 - 18:00</p>
                <p>Sâmbătă: 10:00 - 14:00</p>
                <p>Duminică: Închis</p>
              </div>
            </div>

            {/* Contact Form */}
            <div className="contact-form-container">
              <h2>Trimite-ne un Mesaj</h2>
              
              {success && (
                <div className="alert alert-success">
                  ✓ Mesajul a fost trimis cu succes! Te vom contacta în curând.
                </div>
              )}

              {error && (
                <div className="alert alert-error">
                  ✗ {error}
                </div>
              )}

              <form onSubmit={handleSubmit} className="contact-form">
                <div className="form-group">
                  <label htmlFor="name">Nume Complet *</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    placeholder="Introduceți numele dvs."
                  />
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="email">Email *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      placeholder="email@exemplu.ro"
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="phone">Telefon</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="07XX XXX XXX"
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="subject">Subiect *</label>
                  <input
                    type="text"
                    id="subject"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    required
                    placeholder="Care este motivul contactării?"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="message">Mesaj *</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows="6"
                    placeholder="Scrie-ne mesajul tău aici..."
                  />
                </div>

                <button type="submit" className="btn btn-submit" disabled={loading}>
                  {loading ? 'Se trimite...' : 'Trimite Mesajul'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;



